import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { useStore } from '../../stores/store';

import { isFeatureRequired } from '../../utils/client/client.utils';
import { Link } from '../../common/typography/typography.styles';

const useSenderTip = () => {
  const {
    parcelCreationStore: { shipment, countryDeparture },
    localizationsStore: { selectedLocalization },
    marketingStore: { getAgentExcludedLocationsLink },
  } = useStore();

  const senderTip = useMemo(() => {
    const serviceType =
      shipment?.sender?.carrier?.delivery_service?.service_type;

    if (
      serviceType === 'agent' &&
      isFeatureRequired('showAgentSenderTip', countryDeparture?.code)
    ) {
      const link = getAgentExcludedLocationsLink(selectedLocalization?.code);
      return (
        <Trans
          i18nKey='predeclared_info_tip'
          components={{
            // eslint-disable-next-line
            1: (
              <Link
                $fontWeight='400'
                href={link}
                target='_blank'
                rel='noopener noreferrer'
              />
            ),
          }}
          values={{
            excludedLocationsLink: getAgentExcludedLocationsLink(
              selectedLocalization?.code
            ),
          }}
        />
      );
    }
  }, [
    shipment?.sender?.carrier?.delivery_service?.service_type,
    countryDeparture?.code,
    selectedLocalization?.code,
    getAgentExcludedLocationsLink,
  ]);

  return senderTip;
};

export default useSenderTip;
